<template>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :rules="rules" :model="form" :label-col="{span:3}" :wrapper-col="{span:10}">
      <a-button size='small' @click="()=>{$router.push({path:'/onlineOrder/discount/index'})}" class="m-b-20">
        <LeftOutlined />返回
      </a-button>
      <SmallSquare content="基本信息" class="m-b-20" />
      <a-form-item ref="tem_name" label="模板名称" name="tem_name">
        <a-input placeholder="模板名称" v-model:value="form.tem_name" :maxlength="20">
          <template #suffix>
            {{form.tem_name.length}}/20
          </template>
        </a-input>
      </a-form-item>
      <a-form-item ref="remark" label="备注" name="remark" help="不在前端显示，方便工作人员对模板进行关联">
        <a-textarea v-model:value="form.remark" showCount :maxlength="50" />
      </a-form-item>
      <SmallSquare content="通用规则" class="m-b-20" />
      <a-form-item ref="spec_many" label="支付方法" name="spec_many">
        商品兑换积分*折扣率=订货支付积分
      </a-form-item>
      <a-form-item ref="discount_rate" label="折扣率" name="discount_rate">
        <a-input-number placeholder="折扣率" v-model:value="form.discount_rate" :min="0" :max="100" :precision="0">
        </a-input-number> %
      </a-form-item>
      <a-form-item ref="precision" label="精度处理" name="precision" help="（计算得出的订货支付积分小于1时，实际收取1积分)">
        <a-select v-model:value="form.precision" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option :value="0">保留整数</a-select-option>
        </a-select>
      </a-form-item>
      <SmallSquare content="特殊商品  (下列商品可不遵循通用规则,单独配置订单支付积分)" class="m-b-20" />
      <a-button class="m-b-20" @click="openGoods" v-if="$route.query.type!='edit'">选择商品</a-button>
      <p class='m-b-20'>共{{goodList.length}}件商品</p>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='goodList'>
        <template v-slot:product_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>
              <p class="s_omit2" style="width:200px">{{record.product_name}}</p>
              <p class="s_omit2" style="width:200px">{{record.sku_name}} </p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:value="{ record }">
          <a-input-number v-model:value="record.value"  :precision="0" v-if="$route.query.type!='edit'"></a-input-number>
          {{record.point_price}}
        </template>
        <!-- <template v-slot:action="{ index }">
          <a-buuton type="link" @click="del(index)" :disabled="$route.query.type=='edit'">删除</a-buuton>
        </template> -->
      </a-table>
      <a-form-item :wrapper-col="{span:4}">
        <a-button class="m-t-20" @click="submit" type="primary" style="cursor: pointer;">保存</a-button>
      </a-form-item>
    </a-form>
    <a-modal title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
      <selectOnlineSkuGoods v-on:select="goodSelect" :selectList='goodList' :checkout="true"></selectOnlineSkuGoods>
    </a-modal>
  </a-card>
</template>

<script>
import { ref } from "@vue/reactivity";
import { LeftOutlined } from "@ant-design/icons-vue";
import { createPriceTem,detailPriceTem,detailGoodsPriceTem,editPriceTem } from "@/api/online";
import store from "@/store";
import { message } from "ant-design-vue";
import { iscode } from "../../../../utils/app";
import { inject, onMounted } from "@vue/runtime-core";
export default {
  components: { LeftOutlined },
  setup() {
    const form = ref({
  tem_name: "",
  remark: "",
  discount_rate: null,
  precision: 0,
  tem_goods_data: [],
});
    let columns = [
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
        width: 300,
        slots: { customRender: "product_name" },
      },
      {
        title: "商品分组",
        dataIndex: "category_name",
        key: "category_name",
      },
      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
      },
      {
        title: "支付积分",
        dataIndex: "product_price",
        key: "product_price",
        slots: { customRender: "value" },
      },
      {
        title: "状态",
        dataIndex: "goods_status_text",
        key: "goods_status_text",
      },
      // {
      //   title: "操作",
      //   key: "action",
      //   width: 120,
      //   slots: { customRender: "action" },
      // },
    ];
    const ruleForm = ref();
    const rules = {
      tem_name: [{ required: true, message: "请输入模板名称" }],
      discount_rate: [{ required: true, message: "请输入折扣率" }],
    };
    // 选择商品
    const goodsHooks = function () {
      const showGood = ref(false);
      const goodList = ref([]);
      // 开启弹窗
      const openGoods = () => {
        showGood.value = true;
      };
      const goodSelect = (data) => {
        console.log(data);
        showGood.value = false;
        goodList.value = data;
      };
      return {
        showGood,
        openGoods,
        goodList,
        goodSelect,
      };
    };

    const { showGood, openGoods, goodList, goodSelect } = goodsHooks();
    const del = (index) => {
      goodList.value.splice(index, 1);
    };
   
    const $router = inject("$router");
    const $route=inject('$route')
     const initData=async()=>{
      let result=await detailPriceTem($route.query.id).then(res=>res.data).catch(error=>error)
      if(iscode(result)){
        form.value=result.data
      }else{
        iscode(result,true)
      }
    }
    const submit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          if (!goodList.value.length) {
            message.error("请选择商品");
          }
          if (goodList.value.filter((v) => v.value).length !=goodList.value.length &&$route.query.type!='edit') {
            message.error("支付积分请填写完整");
            return
          }
          var tem_goods_data = [];
          goodList.value.forEach((v) => {
            console.log(v)
            tem_goods_data.push({
              key: v.goods_id+'-'+v.sku_id+'-'+v.key,
              value: v.value ||v.point_price,
            });
          });
          let result;
          if($route.query.type=='edit'){
         result = await editPriceTem($route.query.id,{ ...form.value, tem_goods_data })
            .then((res) => res.data)
            .catch((error) => error);
          }else{
              result = await createPriceTem({ ...form.value, tem_goods_data })
            .then((res) => res.data)
            .catch((error) => error);
          }
         
          if (iscode(result, true)) {
            $router.go(-1);
          }
        })
        .then((error) => {});
    };
    const getGoods=async ()=>{
      let result=await detailGoodsPriceTem({id:$route.query.id}).then(res=>res.data).catch(error=>error)
      console.log(result)
      goodList.value=result.data
    }
    onMounted(()=>{
      if($route.query.type=='edit'){
        initData()
        getGoods()
      }
    })
    return {
      form,
      ruleForm,
      info: store.state.user.info,
      columns,
      rules,
      submit,
      showGood,
      openGoods,
      goodList,
      del,
      goodSelect,
    };
  },
};
</script>